import { Stack, Typography } from '@mui/material'
import { MapLocationCard } from 'src/_modules/common'
import ContactDetails from 'src/_modules/common/Details/ContactDetailsCard'
import AddressCard from '../AddressCard'
import CustomerViewDetails from './CustomerViewDetails'
import { useTranslation } from 'react-i18next'
import Sender3nabDialog from '../Sender3nabDialog'
import { useSelector } from "react-redux";
import { ENAAB_ID_MAPIT_SHIP } from 'src/constants'

export default function ReciverDetailsTab({
  tempOrder,
  handleOrderChange,
  validationErrors,
  viewMode = false,
  disableEditing = false
}) {
  const { t } = useTranslation()
  console.log("tempOrder" , tempOrder);
  const { profile } = useSelector((state) => state.entities.profile);
  if (viewMode) {
    return (
      <Stack spacing={2}>
        <CustomerViewDetails tempOrder={tempOrder} />
        <MapLocationCard
          handleChange={({ target: { name, value } }) => handleOrderChange({ target: { name: `user.location.${name}`, value } })}
          coordinates={tempOrder?.user?.location?.coordinates}
          error={validationErrors?.user?.location?.coordinates}
        />
      </Stack>
    )
  }
const enabId = ENAAB_ID_MAPIT_SHIP.includes( profile?.merchant?.id)

  return (
    <Stack spacing={2}>
      <Typography variant="h4">{t("User's Info")}</Typography>
      {enabId &&  <Sender3nabDialog
        contact={tempOrder?.sender}
        validationErrors={validationErrors?.sender}
        handleChange={({ target: { name, value } }) => {
          handleOrderChange({ target: { name: `sender.${name}`, value } })
        }}
      /> }
     
        {/* Contact and address */}
      <ContactDetails
        contact={tempOrder?.user}
        validationErrors={validationErrors?.user}
        handleChange={({ target: { name, value } }) => {
          handleOrderChange({ target: { name: `user.${name}`, value } })
        }}
      />

      <AddressCard
        address={tempOrder?.user?.address}
        handleChange={({ target: { name, value } }) => {
          name = ["address", "location.coordinates"].includes(name) ? `user.${name}` : `user.address.${name}`
          handleOrderChange({ target: { name: name, value: value } })
        }}
        nationalAddressRequired={true}
        validationErrors={validationErrors?.user?.address}
        disableNationalAddress={disableEditing}
      />
      <MapLocationCard
        handleChange={({ target: { name, value } }) => handleOrderChange({ target: { name: `user.location.${name}`, value } })}
        coordinates={tempOrder?.user?.location?.coordinates}
        error={validationErrors?.user?.location?.coordinates}
      />
    </Stack>
  )
}
